
import state from '../Exams/Exam_state';
import mutations from '../Exams/Exam_mutations';
import getters from '../Exams/Exam_getters';
import actions from '../Exams/Exam_actions';


export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Modules/examModule.js